<template>
  <div>
    <label v-if="docLabel">
      {{ docLabel }}
    </label>
    <div v-if="disabled" class="example-avatar p-1 text-center">
      <img v-if="fileUrl" :src="fileUrl" class="avatar-upload-photo" />
      <div v-else>
        <p class="text-primary">No Current Upload</p>
      </div>
    </div>
    <div v-else class="example-avatar p-1">
      <div v-show="$refs.upload && $refs.upload.dropActive" :class="[noOverlay ? 'drop-active-no-overlay' : 'drop-active']">
        <h3>Drop files to upload</h3>
      </div>
      <div v-show="!edit" class="avatar-upload">
        <div class="text-left">
          <label :for="inputId" class="w-100 d-flex" style="height: 100px">
            <div v-if="files.length || fileUrl" class="m-auto mt-2 position-relative w-100">
              <a v-if="isAString" :href="downloadPath ? `/b-api/${downloadPath}/${fileUrl}` : ''" :download="displayName" target="_blank">
                <button
                  class="btn btn-primary btn-sm"
                  :style="{
                    position: 'absolute',
                    'max-height': '80px',
                    top: '-21px',
                    right: '35px',
                    transform: 'translate(-50%, -50%)',
                  }"
                >
                  <i class="text-white fa fa-download" />
                </button>
              </a>
              <button
                v-if="allowDelete"
                class="btn btn-danger btn-sm"
                :style="{
                  position: 'absolute',
                  'max-height': '80px',
                  top: '-21px',
                  right: '-13px',
                  transform: 'translate(-50%, -50%)',
                }"
                @click.prevent="removeImage"
              >
                X
              </button>
              {{ displayName }}
            </div>
            <div v-else class="m-auto">
              <div v-if="$refs.upload && !$refs.upload.dropActive && noOverlay">
                <h4 class="pt-2 d-inline">Click or Drop File</h4>
              </div>
              <div v-else>
                <h4 class="pt-2 d-inline">Drop File Here</h4>
              </div>
              <i class="fas fa-cloud-upload-alt d-block pt-2" />
            </div>
          </label>
        </div>
        <div class="text-center p-2">
          <file-upload
            ref="upload"
            v-model="files"
            :extensions="extensions"
            :accept="accept"
            :input-id="inputId"
            class="btn btn-primary"
            :drop="!edit"
            @input-filter="inputFilter"
            @input-file="inputFile"
          >
            Click or Drop File
          </file-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from "../common/FileUpload.js";
import { mapActions } from "vuex";

export default {
  components: {
    FileUpload,
  },
  props: {
    extensions: { type: String, default: "gif,jpg,jpeg,png,pdf" },
    accept: { type: String, default: "image/png,image/gif,image/jpeg,application/pdf" },
    disabled: { type: Boolean, default: false },
    allowDelete: { type: Boolean, default: false },
    inputId: { type: String, default: "avatar" },
    fileUrl: { type: [String, Object] },
    resetImage: { type: Boolean, required: false, default: false },
    noOverlay: { type: Boolean, default: false },
    docLabel: { type: String, required: false },
    downloadPath: { type: String, required: false },
  },
  emits: ["createDocument", "deleteDocument"],
  data() {
    return {
      tempName: null,
      files: [],
      edit: false,
      cropper: false,
    };
  },

  computed: {
    isAString() {
      if (this.fileUrl && (typeof this.fileUrl === "string" || this.fileUrl instanceof String)) {
        return true;
      }
      return false;
    },
    displayName() {
      if (this.isAString) {
        const n = this.fileUrl.lastIndexOf("/"); // strip path
        const x = this.fileUrl.indexOf("-", n); // strip timestamp
        return this.fileUrl.substring(x + 1);
      }
      if (this.fileUrl && this.fileUrl.name) {
        return this.fileUrl.name;
      }
      return "";
    },
  },
  methods: {
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    createFile(file, cb) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function readResult() {
        cb(reader.result);
      };
      reader.onerror = function (error) {
        // There was an error reading doc
      };
    },
    inputFile(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.tempName = null;
          this.addingLabel = true;
          this.save();
        });
      }
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp|pdf)$/i.test(newFile.name)) {
          this.setSnackbar({ variant: "info", message: "Non-Supported File Type" });
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = "";
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    save() {
      this.addingLabel = false;
      const file = this.files[0];
      this.createFile(file.file, (result) => {
        const upload = {
          file: result,
          name: file.name.replace(/\s+/g, "-"),
          ext: file.name.substring(file.name.lastIndexOf("."), file.name.length),
          mime_type: file.type,
          label: this.docLabel,
          size: file.size,
        };
        this.tempName = upload.name;
        this.$emit("createDocument", upload);
        this.label = null;
        this.files = [];
        this.addingLabel = false;
      });
    },
    removeImage() {
      const data = {
        inputId: this.inputId,
        fileUrl: this.fileUrl,
        file: this.files && this.files[0],
      };
      this.$emit("deleteDocument", data);
    },
  },
};
</script>

<style scoped>
:deep(label) {
  /* border: 2px dashed grey; */
  text-align: center;
}
:deep(.avatar-upload div:nth-child(2)) {
  display: none;
}
.example-avatar {
  border: 2px dashed grey;
}
:deep(.cropper-point.point-se) {
  bottom: -3px;
  cursor: nwse-resize;
  height: 5px;
  opacity: 1;
  right: -3px;
  width: 5px;
}
.avatar-upload-photo {
  /* max-width: 200px;
    max-height: 90px; */
  max-height: 100px;
  max-width: 100%;
}
.example-avatar .avatar-edit-image {
  max-width: 100%;
}
.example-avatar .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.example-avatar .drop-active-no-overlay {
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.example-avatar .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
.example-avatar .drop-active-no-overlay h3 {
  display: none;
}
</style>
